import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Shell } from "@/components/layout/Shell";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Shell className="flex items-center justify-center text-center">
      <Helmet>
        <meta name="robots" content="noindex" />
        <title>404 - Page not found | Subtrackr</title>
        <meta name="description" content="Sorry, the page you are looking for does not exist on Subtrackr." />
      </Helmet>
      <div className="max-w-md space-y-6 animate-fade-in">
        <h1 className="text-7xl font-bold text-primary">404</h1>
        <h2 className="text-3xl font-semibold">{t('pageNotFound')}</h2>
        <p className="text-muted-foreground">
          {t('pageNotFoundDesc')}
        </p>
        <Button asChild size="lg">
          <Link to="/">{t('backToHome')}</Link>
        </Button>
      </div>
    </Shell>
  );
};

export default NotFound;
